"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

/**
 * Views for the manager approval-workflow read tools (approval queue, report
 * review). Merged into `concurToolRegistry` by the registry wiring.
 */
export const concurApprovalToolRegistry = {
  concurListApprovals: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./approval-views").then(({ ConcurListApprovalsToolView }) => ({
        default: ConcurListApprovalsToolView,
      }))
    ),
  },
  concurGetApprovalReport: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./approval-views").then(
        ({ ConcurGetApprovalReportToolView }) => ({
          default: ConcurGetApprovalReportToolView,
        })
      )
    ),
  },
  concurGetComments: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./comment-views").then(({ ConcurGetCommentsToolView }) => ({
        default: ConcurGetCommentsToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
